<template>
  <b-card>
    <b-row>
      <b-col sm="5" class="text-left">
        <h4 id="traffic" class="card-title">Income</h4>
        <div class="small text-muted">{{ date | moment('YYYY') }}</div>
      </b-col>
      <!-- <b-col sm="7" class="d-none d-md-block">
        <b-button-toolbar class="float-right">
          <b-form-radio-group id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
            <b-form-radio class="mx-0" value="day">Day</b-form-radio>
            <b-form-radio class="mx-0" value="type">Type</b-form-radio>
          </b-form-radio-group>
        </b-button-toolbar>
      </b-col> -->
    </b-row>
    <year-chart
      class="chart-wrapper"
      style="height:300px;margin-top:40px;"
      height="300"
      :date="date"
    />
  </b-card>
</template>

<script>
import YearChart from '@/components/Chart/YearChart'

export default {
  name: 'yearly-chart',
  components: {
    YearChart
  },
  props: ['date']
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/YearlyChart.vue